import { DateTimeField } from "@rawa/ui/DateTimeField"
import { fieldInstructions, fieldName } from "../fields"
import type { ControlRenderer } from "./types"

export const dateTimePicker: ControlRenderer<"dateTimePicker"> = {
  Render: ({ field, value, onChange, readOnly, error }) => (
    <DateTimeField
      id={field.id}
      label={fieldName(field)}
      hint={fieldInstructions(field)}
      value={value}
      onChange={onChange}
      required={field.required}
      readOnly={readOnly}
      error={error}
    />
  ),
}
